import React from 'react'
import SearchBar from '../components/SearchBar'
import '../SearchPage.css'
import { useStateValue } from '../StateProvider'
import useGoogleSearch from '../useGoogleSearch';
import response from '../response'
import { Link } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import DescriptionIcon from '@mui/icons-material/Description';
import ImageIcon from '@mui/icons-material/Image';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RoomIcon from '@mui/icons-material/Room';
import MoreVertIcon from '@mui/icons-material/MoreVert';

// AIzaSyBAs5cVHyY6iu2_jE_8WjhZqefXQjcZCJA

export default function SearchPage() {
    const[{ term }, dispatch] = useStateValue(); /* pull */
    const { data } = useGoogleSearch(term); /* use pulled term inside custom hook */

    // const data = response; /* so we don't keep hitting the actual API### (API limit issues(100 daily)) */
    console.log(data);
  return (
    <div className="searchPage">
        <div className="searchPage__header">
            <Link to="/">
                <img src="https://pngimg.com/d/google_PNG19644.png" alt="" className="searchPage__logo" />
            </Link>
        <div className="searchPage__headerBody">
            <SearchBar hideButtons={true} autoFocus={false}/>
            <div className="searchPage__options">
                <div className="searchPage__optionsLeft">
                    <div className="searchPage__option">
                        <SearchIcon />
                        <Link to="/all">All</Link>
                    </div>                   
                    <div className="searchPage__option">
                        <DescriptionIcon />
                        <Link to="/news">News</Link>
                    </div>
                    <div className="searchPage__option">
                        <ImageIcon />
                        <Link to="/images">Images</Link>
                    </div>
                    <div className="searchPage__option">
                        <LocalOfferIcon />
                        <Link to="/shopping">Shopping</Link>
                    </div>
                    <div className="searchPage__option">
                        <RoomIcon />
                        <Link to="/maps">Maps</Link>
                    </div>
                    <div className="searchPage__option">
                        <MoreVertIcon />
                        <Link to="/more">More</Link>
                    </div>
                </div>
                <div className="searchPage__optionsRight">
                    <div className="searchPage__option">
                        <Link to="/settings">Settings</Link>
                    </div>
                    <div className="searchPage__option">
                        <Link to="/tools">Tools</Link>
                    </div>
                </div>
            </div>
        </div>
        </div>
        {term && (
        <div className="searchPage__results">
            <p className="searchPage__resultCount">
                About {data?.searchInformation.formattedTotalResults} results ({data?.searchInformation.formattedSearchTime} seconds) for {term}
            </p>
            {data?.items.map(item => {
                return <div className="searchPage__result">
                    <div className="searchPage__linkContainer">
                    <a href={item.link}>
                    {item.pagemap?.cse_image?.length > 0 && item.pagemap?.cse_image[0]?.src && (
                        <img src={item.pagemap?.cse_image[0]?.src} alt="" className="searchPage__resultImage" />

                    )}
                    </a>
                    <div className="searchPage__linkHead">
                    <a href={item.link}className="searchPage__siteTitle">
                        {item.pagemap?.metatags[0]['og:site_name']}
                    </a>
                    <a href={item.link}>{item.displayLink}
                    </a>
                    </div>
                    </div>
                    <a href={item.link} className="searchPage__resultTitle">
                        <h2>{item.title}</h2>
                    </a>
                    <p className="searchPage__resultSnippet">
                        {item.snippet}
                    </p>
                </div>
            })}
        </div>
            )}
    </div>
  )
}
